/** How long the first render waits for the start language's bundle. */
export const FIRST_RENDER_WAIT_MS = 4000;

/** Resolves when ``ready`` settles or after ``ms``, whichever comes
 *  first, and says which. Never rejects.
 *
 *  i18nReady already resolves when a locale chunk fails (a 404 from a
 *  stale SPA). This covers a chunk that stalls instead (a slow proxy, a
 *  flaky mobile link), which would otherwise hold a blank page for as
 *  long as the request hangs. The app then renders in English, and when
 *  the bundle does land i18next emits ``languageChanged``, which
 *  re-renders every useTranslation() consumer in the start language. */
export function firstRenderGate(
  ready: Promise<unknown>,
  ms: number = FIRST_RENDER_WAIT_MS,
): Promise<"ready" | "timeout"> {
  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      console.warn(
        `i18n: the start language is still loading after ${ms} ms; rendering in English until it arrives`,
      );
      resolve("timeout");
    }, ms);
    const settle = (): void => {
      clearTimeout(timer);
      resolve("ready");
    };
    ready.then(settle, settle);
  });
}
